import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SearchedInfo } from "../../model/searchedinfo";

@Injectable({
  providedIn: "root",
})
export class LastSearchService {
  private lastSearchsSubject = new BehaviorSubject<SearchedInfo[]>([]);

  public lastSearchs$ = this.lastSearchsSubject.asObservable();

  public addLastSearch(searchedInfo: SearchedInfo): void {
    const searchList = this.lastSearchsSubject.getValue();

    if (this.searchInfoAlreadyExist(searchList, searchedInfo)) {
      return;
    }

    if (searchList.length < 5) {
      searchList.push(searchedInfo);
    } else {
      searchList.shift();
      searchList.push(searchedInfo);
    }

    this.lastSearchsSubject.next(searchList);
  }

  private searchInfoAlreadyExist(searchList: SearchedInfo[], searchedInfo: SearchedInfo): boolean {
    return !!searchList.find(
      (obj) => obj.formattedAddress === searchedInfo.formattedAddress || obj.location === searchedInfo.location,
    );
  }
}
